<script context="module">
    export function draggable(node, id) {
        let last;

        let top = node.offsetTop;
        let left = node.offsetLeft;

        let handle_node = node.querySelector(".drag-handle")


        // see if our dimensions are saved
        if (id) {
            let savedPosition = window.localStorage.getItem(`popup_location_${id}`);
            if (savedPosition) {
                savedPosition = JSON.parse(savedPosition);

                top = savedPosition.top;
                left = savedPosition.left;

                node.style.top = top + 'px';
                node.style.left = left + 'px';
                checkPosition();
            }
        }

        // make sure we are on the page
        function checkPosition() {
            if (top >= window.innerHeight - node.clientHeight) {
                if (node.clientHeight){
                    top = window.innerHeight - node.clientHeight;
                } else {
                    top = window.innerHeight - 500;
                }

                if (top < 0) {
                    top = 0;
                }

                node.style.top = top + "px";
            }

            if (left >= window.innerWidth - node.clientWidth) {
                if (node.clientWidth) {
                    left = window.innerWidth - node.clientWidth;
                } else {
                    left = window.innerWidth - 500;
                }

                if (left < 0) {
                    left = 0;
                }

                node.style.left = left + "px";
            }
        }


        function handleMouseDown(evt) {
            // get current top and left
            top = node.offsetTop;
            left = node.offsetLeft;

            last = {
                x: evt.clientX,
                y: evt.clientY
            }

            document.body.addEventListener("mousemove", handleMouseMove);
            return false;
        }

        function handleMouseUp(evt) {
            document.body.removeEventListener("mousemove", handleMouseMove);

            window.localStorage.setItem(`popup_location_${id}`, JSON.stringify({
                top: top,
                left: left
            }))
        }

        function handleMouseMove(evt) {
            top += (evt.clientY - last.y);
            left += (evt.clientX - last.x);

            node.style.top = top + "px";
            node.style.left = left + "px";

            last = {
                x: evt.clientX,
                y: evt.clientY
            }
        }


        handle_node.addEventListener("mousedown", handleMouseDown);
        handle_node.addEventListener("mouseup", handleMouseUp);

        window.addEventListener("resize", checkPosition)

        return {
            destroy: () => {
                // remove event listeners
                handle_node.removeEventListener("mousedown", handleMouseDown);
                handle_node.removeEventListener("mouseup", handleMouseUp);
                document.body.removeEventListener("mousemove", handleMouseMove);
                window.removeEventListener("resize", checkPosition)
            }
        }
    }
</script>